import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
import {Button, Modal} from "react-bootstrap";
import {
  selectIsCurrentDestinationValid, selectIsSaveEnabled,
} from '../../../selectors';
import {
  getFileFrameRate,
  onSubmitDestination,
  selectMemfisWoLKFS,
  setErrorNumberFrameRateValue,
  setNewFrameRate,
  showFrameRateModal,
  STORAGE_MNG_LKFS_AUTO_CHOOSE_DESTINATION,
  STORAGE_MNG_LKFS_AUTO_UPDATE_AMB,
  STORAGE_MNG_LKFS_GOTO_SCREEN,
  STORAGE_MNG_LKFS_RESET,
  STORAGE_MNG_LKFS_UPDATE_AMB,
  STORAGE_MNG_LKFS_UPDATE_WO_MEMFIS,
} from "../../../actions";
import TextEllipsisAdvanced from '../../../../../components/TextEllipsis/TextEllipsisAdvanced';
import {getValueForOS} from '../../../utils';
import store from "../../../../../store";
import PropTypes from "prop-types";
import {ModalContainer} from "../../../../../components/Wizard/Wizard";
import SelectDestinationView from "./SelectDestinationView";
import SelectWOMemfisView from "./SelectWOMemfisView";

const onGotoScreen = (newScreen, fsRoots) => ({ type: STORAGE_MNG_LKFS_GOTO_SCREEN, newScreen, fsRoots });

const CustomPathFieldStyled = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  > label, > span {
    margin: 0 16px 0 0;
    padding: 0;
    flex: 0 0 140px;
    color: #282828;
    font-size: 14px;
    font-weight: bold;
    text-align: left;

    + div:not(.checkbox) {
      max-width: calc(100% - 140px - 16px);
      flex-grow: 1;
      &.destination-wrapper {
        display: flex;
        align-items: center;
        .destination-value {
          flex-grow: 1;
          max-width: calc(100% - 42px/*button width*/ - 16px);
        }
        &.with-reset-btn {
          .destination-value {
            max-width: calc(100% - 42px/*button width*/ - 16px - 41px/*button width*/ - 16px);
          }
        }
      }
    }
  }

  .checkbox-label {
    input[type="checkbox"] {
      margin: 0 7px 0 0;
    }
  }

  .content {
    .error, .error:focus, .error:hover {
      border: 2px solid red;
    }

    p.bg-danger {
      max-width: 200px;
      padding: 4px;
      margin-top: 1px;
      position: absolute;
      margin-left: -4px;
    }
  }

  .fr-determ {
    width: 100%;
    padding: 5px;
  }
`;

/*#region InitialScreen */
const InitialLayoutStyled = styled.div`
  .amb-settings {
    label {
      margin: 5px 5px 5px 0;
      padding: 15px 15px 15px 0;
      > input[type=checkbox] {
        margin-right: 10px;
      }
    }
  }

  button {
    margin-left: 16px;
  }
  .select-destination, .destination-reset {
    max-height:34px;
  }
  .channel-sets-btn button {
    margin-left: 0;
  }
`;

function InitialScreen(props) {
  const {
    AMBCurrent,
    WOMemfis,
    destination,
    fsRoots,
    initialDestination,
    isAutoWO,
    onGotoScreen,
    openFrameRateModal,
    onUpdateAMB,
    onReset,
    frameRate,
    errorType,
    setNewFrameRate,
    newFrameRate,
    isErrorNumberFrameRate,
    errorQcProject,
    isEnable,
    isSaveEnabled,
    isSelectingDestination,
    isSelectingWOMemfis,
    onConfirmDestination,
  } = props;

  const [selectedFolder, setSelectedFolder] = useState(null);

  const findWoFromLinkedFile = isAutoWO;

  const checked1 = Boolean(Number(AMBCurrent) & 1);
  const checked3 = Boolean(Number(AMBCurrent) & 2);
  const checked4 = Boolean(Number(AMBCurrent) & 8192);
  const className = ((errorType !== null && errorType !== "success") && newFrameRate === null) || isErrorNumberFrameRate ? 'error' : '';
  const btnClassName = ((errorType !== null && errorType !== "success") && newFrameRate === null) || isErrorNumberFrameRate ? 'btn-danger' : 'bg-info';

  const { checkedItems, onSubmitWO } = props;

  useEffect(() => {
    if (!WOMemfis && checkedItems) {
      let result = /WO[0-9]{7}/gm.exec(checkedItems[0].key);
      if (!result) {
        result = /WO[0-9]{7}/gm.exec(checkedItems[0].fullPath);
      }
      if (result) {
        const value = result[0];
        const rootID = checkedItems[0].fsRootID;
        const contentID = checkedItems[0].contentID;
        onSubmitWO(value, rootID, contentID);
      }
    }
  }, [WOMemfis, checkedItems, onSubmitWO]);

  const allowContinue = () => {
    return isSaveEnabled;
  }

  const onSelectFolder = (folder) => {
    setSelectedFolder(folder);
  }

  const renderBody = () => {
    if (isSelectingDestination) {
      return (
        <SelectDestinationView
          selectedFolder={selectedFolder}
          setSelectedFolder={(folder) => onSelectFolder(folder)}
        />
      );
    }

    if (isSelectingWOMemfis) {
      return (
        <SelectWOMemfisView/>
      );
    }

    return (
      <InitialLayoutStyled>
        <CustomPathFieldStyled>
          <span className='label'>WO#</span>
          <div className='content'>
            <input type='text' disabled={true} value={WOMemfis} />
            {
              findWoFromLinkedFile ? null : <Button
                bsStyle='primary'
                onClick={() => onGotoScreen('isSelectingWOMemfis')}
              >
                Select WOMemfis
              </Button>
            }
          </div>
        </CustomPathFieldStyled>
        <CustomPathFieldStyled>
          <span className='label'>Destination</span>
          <div className='content destination-wrapper with-reset-btn'>
            <TextEllipsisAdvanced
              className="destination-value"
              data={getValueForOS(destination, 'key')}
              defaultText="[No Folder Selected]"
            />
            <Button
              bsStyle='primary'
              className='select-destination'
              title="Select Destination"
              onClick={() => onGotoScreen('isSelectingDestination', fsRoots)}
            >
              <i className="far fa-folder-tree"/>
            </Button>
            <Button
              className='destination-reset'
              disabled={initialDestination.key === destination.key}
              title="Reset"
              onClick={() => onReset('destination')}
            >
              <i className="fa-light fa-folder-xmark"/>
            </Button>
          </div>
        </CustomPathFieldStyled>
        <CustomPathFieldStyled>
          <span className='label'>AMB Settings</span>
          <div className='content amb-settings'>
            <label>
              <input type='checkbox'
                     id='amb_1'
                     name='amb_1'
                     checked={checked1}
                     onChange={() => onUpdateAMB(!checked1, checked3, checked4)}
              />
              1770_1
            </label>
            <label>
              <input type='checkbox'
                     id='amb_3'
                     name='amb_3'
                     checked={checked3}
                     onChange={() => onUpdateAMB(checked1, !checked3, checked4)}
              />
              1770_3
            </label>
            <label>
              <input type='checkbox'
                     id='amb_4'
                     name='amb_4'
                     checked={checked4}
                     onChange={() => onUpdateAMB(checked1, checked3, !checked4)}
              />
              1770_4
            </label>
          </div>
        </CustomPathFieldStyled>
        {isEnable ?
          <CustomPathFieldStyled>
            <span className='label'>Frame Rate</span>
            <div className='content'>
              <input
                type='text'
                className={className}
                value={newFrameRate !== null ? newFrameRate : frameRate}
                onChange={(e) => setNewFrameRate(e.target.value)}
              />
              &nbsp;
              {errorType !== null && errorType !== "success" ?
                <button
                  type="button"
                  className={'btn ' + btnClassName}
                  onClick={() => openFrameRateModal()}
                  title="See error details"
                >
                  explain
                </button> : null
              }
              {isErrorNumberFrameRate && !errorQcProject ?
                <p className="bg-danger">Frame rate must be a number</p>
                : null
              }
            </div>
          </CustomPathFieldStyled> : null
        }
        { errorQcProject ?
          <CustomPathFieldStyled>
            <p className="bg-danger fr-determ">Frame rate can not be determined</p>
          </CustomPathFieldStyled> : null
        }
      </InitialLayoutStyled>
    );
  }

  const renderButtons = () => {
    if (isSelectingDestination) {
      return (
        <>
          <Button
            bsStyle="default"
            onClick={() => onGotoScreen()}
          >
            Back
          </Button>
          <Button
            bsStyle="primary"
            disabled={!selectedFolder}
            onClick={() => onConfirmDestination(selectedFolder)}
          >
            Continue
          </Button>
        </>
      )
    }

    if (isSelectingWOMemfis) {
      return (
        <>
          <Button
            bsStyle="default"
            onClick={() => onGotoScreen()}
          >
            Back
          </Button>
        </>
      )
    }

    return (
      <>
        <Button
          bsStyle="primary"
          disabled={!allowContinue()}
          onClick={props.onContinue}
        >
          {showConfigureAudioChannelsBtn ? 'Continue' : 'Submit'}
        </Button>
      </>
    );
  }

  const {email} = store.getState().user;
  const showConfigureAudioChannelsBtn = email && true; //(email.includes('berkman') || email.includes('morozov'));

  return (
    <>
      <Modal.Body>
        <ModalContainer className="container-fluid">
          {renderBody()}
        </ModalContainer>
      </Modal.Body>
      <Modal.Footer>
        {renderButtons()}
        <Button
          bsStyle="default"
          onClick={props.onCancel}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </>
  );
}

function mapStateToProps(state) {
  const {fsRoots, checkedItems} = state.storageManager;
  const {
    AMBCurrent,
    AMBInitial,
    currentDestination,
    initialDestination,
    currentWOMemfis,
    isAutoWO,
    frameRate,
    dbFrameRate,
    errorType,
    newFrameRate,
    isErrorNumberFrameRate,
    errorQcProject,
    isSelectingDestination,
    isSelectingWOMemfis,
    //isSaveEnabled,
    isEnable
  } = state.storageManager.LKFSModalState;
  return {
    AMBCurrent,
    AMBInitial,
    WOMemfis: currentWOMemfis,
    destination: currentDestination,
    fsRoots,
    isAutoWO,
    initialDestination,
    isCurrentDestinationValid: selectIsCurrentDestinationValid(state),
    frameRate,
    dbFrameRate,
    errorType,
    newFrameRate,
    isErrorNumberFrameRate,
    errorQcProject,
    isEnable,
    checkedItems,
    isSelectingDestination,
    isSaveEnabled: selectIsSaveEnabled(state),
    isSelectingWOMemfis,
  };
}

function mapDispatchToState(dispatch) {
  return {
    onReset: (resetField) => dispatch({ type: STORAGE_MNG_LKFS_RESET, resetField }),
    onUpdateAMB: (new1, new3, new4) => dispatch({ type: STORAGE_MNG_LKFS_UPDATE_AMB, new1, new3, new4 }),
    onGotoScreen: (type, fsRoots) => {
      dispatch(onGotoScreen(type, fsRoots));
    },
    openFrameRateModal: () => {
      dispatch(showFrameRateModal(true));
    },
    setNewFrameRate: (value) => {
      if (!/^-?(0|[1-9]\d*)(\.[0-9]{1,4})?(\/-?(0|[1-9]\d*)(\.[0-9]{1,4})?)?$/.test(value) || value === "0") {
        dispatch(setErrorNumberFrameRateValue(true));
      } else {
        dispatch(setErrorNumberFrameRateValue(false));
      }
      dispatch(setNewFrameRate(value));
    },
    onConfirmDestination: (folder) => dispatch(onSubmitDestination(folder)),
    onSubmitWO: (value, rootID, contentID) => {
      getFileFrameRate(rootID, contentID, value, dispatch);
      selectMemfisWoLKFS(value, rootID, (response) => {
        dispatch({
          type: STORAGE_MNG_LKFS_AUTO_CHOOSE_DESTINATION,
          folder: {
            key: response.data.content.key,
            fsRootID: response.data.content.fsRootID,
          }
        });
        dispatch({
          type: STORAGE_MNG_LKFS_AUTO_UPDATE_AMB,
          numericAMB: response.autoAMB,
        });
      });
      dispatch({
        type: STORAGE_MNG_LKFS_UPDATE_WO_MEMFIS,
        value,
      });
    }
  };
}

InitialScreen.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
};

export const InitialScreenConnected = connect(mapStateToProps, mapDispatchToState)(InitialScreen);
